import { createTheme } from '@mui/material/styles';

/** Brand tokens (#171). */
export const brand = {
  ink: '#0F1B2D',
  teal: '#0E7C7B',
  tealHover: '#0B5F5E',
  page: '#F5F6F8',
  border: '#E4E7EC',
};

/** Permit numbers, IDs and tag names. */
export const MONO = '"IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, monospace';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: brand.teal, dark: brand.tealHover, contrastText: '#fff' },
    secondary: { main: brand.ink },
    background: { default: brand.page, paper: '#fff' },
    divider: brand.border,
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: '"IBM Plex Sans", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
    button: { textTransform: 'none', fontWeight: 500 },
  },
  components: {
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { border: `1px solid ${brand.border}` } },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { border: 'none', backgroundColor: brand.ink, color: '#fff' } },
    },
    MuiButton: {
      styleOverrides: { containedPrimary: { '&:hover': { backgroundColor: brand.tealHover } } },
    },
    MuiTooltip: { styleOverrides: { tooltip: { fontSize: 13 } } },
  },
});
